module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"image_error":"Could not read image file."},"de":{"image_error":"Bilddatei konnte nicht gelesen werden."}}')
  delete Component.options._Ctor
}
